import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import type { NiceAlertConfig } from "@recursyve/nice-ui-kit.v2";

@Component({
    selector: "nerri-custom-alert",
    standalone: false,
    templateUrl: "custom-alert.template.html",
    styleUrls: ["custom-alert.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CustomAlertComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public alertConfig: NiceAlertConfig,
        private dialogRef: MatDialogRef<CustomAlertComponent>
    ) {}

    public confirm() {
        this.dialogRef.close(true);
    }

    public close() {
        this.dialogRef.close(false);
    }
}
